import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { BuscarPersona } from 'src/app/model/persons/buscarpersona.model';
import { AppComponent } from 'src/app/app.component';
import { PersonaService } from 'src/services/persona/persona.service';
import { SweetServices } from 'src/services/sweet.services';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { ComunicacionService } from 'src/services/comunicacion.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ExcelService } from 'src/services/persona/excel.service';
import { AlertasService } from 'src/services/pld/alertas.service';
import { saveAs } from 'file-saver';
import { Helper } from 'src/app/common/Helper/Helper';

import Swal from 'sweetalert2';
import { createWriteStream } from 'streamsaver';
import { AppConstants } from 'src/app/common/enum/app.constants';
import { EnumTipoConsultaOptimizado } from 'src/app/common/enum/TipoPersona.enum';
import { StreamDownloadFetch } from 'src/app/common/Helper/StreamHelper';
import { TableColumn } from '@spot-utils/dynamic-table';
import * as moment from 'moment';

@Component({
  selector: 'app-buscar-persona',
  templateUrl: './buscar-persona.component.html',
  styleUrls: ['./buscar-persona.component.css']
})
export class BuscarPersonaComponent implements OnInit, OnChanges {
  //Stream Download Inicio
  private abortCtrl?: AbortController;
  // Variables para componentes de tabla Inicio
  data: any[] = [];
  columns: TableColumn[] = [];
  totalrows: number = 0;
  pageSize: number = 15;
  loadingTotalRows: boolean = false;
  fromSearchButtom: boolean = false;
  // Variables para componentes de tabla Cierre
  @Input('tipoPersona') tipoPersona: number;
  @Input('paraCaso') paraCaso: boolean = false;
  @Input('open') open: boolean = false;
  @ViewChild('formPersonSearch') formPersonSearch: NgForm;

  persona: BuscarPersona;
  personaResultados: [];
  reporteResultados: any[];
  total: number;
  totalRegistros: number;
  tipoPersonaCombo: number;
  numPage: number;
  contador: number;
  resultadoPaginadoTotal: [];
  personalidadFiscal: [];
  estatus: [];
  sucursales: [];
  areas: [];
  nivelRiesgo: [];
  isNivelRiesgo: boolean = false;
  PersonalidadFiscalId = -1;

  generarReporteAsync = () => {
    this.reporteResultados = [];
    let promise = new Promise((resolve, reject) => {
      this.personaService.reporteGeneral(this.persona, this.tipoPersona).subscribe(response => {
        if (response.isCorrect && response.data.info != null) {
          response.data.info.result.forEach(element => {
            delete (element.sNombre)
            var json = JSON.stringify(element)
              .replace("personalidadFiscal", "Personalidad Fiscal")
              .replace("nombre", "Nombre")
              .replace("sNombre", "Segundo Nombre")
              .replace("aPellidoPaterno", "Apellido Paterno")
              .replace("apellidoMaterno", "Apellido Materno")
              .replace("estadoCivil", "Estado Civil")
              .replace("estatus", "Estatus")
              .replace("sexo", "Sexo")
              .replace("fechaNacimiento", "Fecha de Nacimiento")
              .replace("rfc", "RFC")
              .replace("claveCia", "Número de Cliente")
              .replace("estadoCivil", "Estado Civil")
              .replace("calle", "Calle")
              .replace("numInt", "Número Interior")
              .replace("numExt", "Número Exterior")
              .replace("asentamiento", "Colonia")
              .replace("codigoPostal", "Código Postal")
              .replace("pais", "País de Nacimiento")
              .replace("estadoNacimiento", "Estado de Nacimiento")
              .replace("paisDomicilio", "País del Domicilio")
              .replace("estado", "Estado del Domicilio")
              .replace("municipio", "Municipio del Domicilio")
              .replace("nacionalidad", "Nacionalidad")
              .replace("actividadEconomica", "Actividad Económica")
              .replace("riesgo", "Nivel de Riesgo")
              .replace("contrato", "Contrato")
              .replace("pMontoTotal", "Monto Total")
              .replace("pPagoTotal", "Pago Total")
              .replace("inicioVigencia", "Inicio del Contrato")
              .replace("finVigencia", "Fin del Contrato")
              .replace("instrumento", "Instrumento")
              .replace("curp", "CURP")
              .replace("fechaRegistro", "Fecha de Registro")
              .replace("telefono", "Teléfono")
              .replace("correo", "Correo")
              .replace("fechaIngreso", "Fecha de Ingreso")
              .replace("oficialCumplimiento", "Oficial de Cumplimiento")
              .replace("profesion", "Profesión")
              .replace("titulado", "Titulado")
              .replace("contratacion", "Contratación")
              .replace("estatura", "Estatura")
              .replace("sucursal", "Sucursal")
              .replace("area", "Área")
              .replace("puesto", "Puesto")
              .replace("comite", "Comité")
              .replace("ciudad", "Ciudad")
              .replace("numeroEmpleado", "Número de Empleado")
              .replace('personaId', 'Número de Persona')
              .replace('esPep', 'Es PEP')
              .replace('relacionPEP', 'Relación PEP')
              .replace('esLN', 'Es Lista Negra')
              .replace('montoDepMensuales', 'Monto Deposito')
              .replace('numDepMensuales', 'Número Deposito')
              .replace('montoRetMensuales', 'Monto Retiro')
              .replace('numRetMensuales', 'Número Retiro')
              .replace('divisa', 'Divisa')
              .replace('producto', 'Producto')
              .replace('fechaRegistroPerfil', 'Fecha Registro Perfil')
              .replace('fatca', 'Fatca');
            var jsonReporte = JSON.parse(json);
            this.reporteResultados.push(jsonReporte);
          });
          this.excelService.exportAsExcelFile(
            this.reporteResultados,
            this.nameReport(),
            this.nameReport()
          );
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
    return promise;
  }

  constructor(
    private main: AppComponent,
    private personaService: PersonaService,
    private alertaService: AlertasService,
    private excelService: ExcelService,
    private alerta: SweetServices,
    private catalogoService: CatalogosService,
    private comunicacion: ComunicacionService,
    private router: Router,
    private sHelper: StreamDownloadFetch,
    private Helpers: Helper) {
    this.persona = new BuscarPersona();
    this.tipoPersonaCombo = 2;
    this.personaResultados = [];
    this.personalidadFiscal = this.catalogoService.getPersonalidadFiscal();
    this.estatus = this.catalogoService.getEstatus();
    this.areas = this.catalogoService.getArea();
    this.sucursales = this.catalogoService.getSucursal();
    this.nivelRiesgo = this.catalogoService.getRiesgo();
    this.resultadoPaginadoTotal = [];
  }

  reporteClientes = () => {
    let promise = new Promise((resolve, reject) => {
      this.reporteResultados = [];
      this.alerta.AlertaSuccessTimer(
        "El Reporte se descargará en breve, por favor espere"
      )
      this.personaService.buscarReporteClientes(this.persona).subscribe(response => {
        this.main.loading = false;
        if (response == null) {
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        }
        else if (response.isCorrect === 'false') {
          this.alerta.AlertaError(response.message);
        }
        else if (response.data.total === 0) {
          this.alerta.AlertaSinResultados(response.message);
        }
        else {
          const documento = response.data.info.result;
          const byteString = atob(documento[0]['valueArchivo']);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          let blob = new Blob([ab], { type: documento[0]['fileType'] });
          saveAs(blob, documento[0]['fileName']);
          this.alerta.AlertaSuccessTimer('El Reporte se ha generado con éxito.');
        }
      }, (err) => {
        this.main.loading = false;
        this.alerta.AlertaCatch(err);
      });
    });
    return promise;
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.open) {
      this.personaResultados = undefined;
      this.totalRegistros = 0;
      this.persona = new BuscarPersona();
      this.persona.TipoPersona = 2;
    }
  }

  ngOnInit() {
    this.persona.TipoPersona = this.tipoPersona;
    this.main.loading = false;
    this.total = 0;
    this.totalRegistros = 0;
    this.numPage = 0;
    this.contador = 1;
    this.reemplazarCaracter();
  }

  reemplazarCaracter(): void {
    if (this.persona.ApellidoMaterno.includes('?')) {
      this.persona.ApellidoMaterno = this.persona.ApellidoMaterno.replace('?', 'ñ');
    }
    if (this.persona.ApellidoPaterno.includes('?')) {
      this.persona.ApellidoPaterno = this.persona.ApellidoPaterno.replace('?', 'ñ');
    }
    if (this.persona.Nombre.includes('?')) {
      this.persona.Nombre = this.persona.Nombre.replace('?', 'ñ');
    }
  }

  validarFormulario(formPersonSearch: NgForm) {
    if (formPersonSearch.valid) {
      this.main.loading = true;
      this.persona.Pagina = 1;
      this.buscarPersona();
      setTimeout(() => {
        this.bucarTotalesPersonaOptimizado();
      }, 1000);
    }
  }

  bucarTotalesPersonaOptimizado() {
    this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataCountRows;
    //this.loadingTotalRows = true;
    this.personaService.buscarPersonasConteos(this.persona).subscribe(response => {
      this.loadingTotalRows = false;
      if (response.isCorrect == 'true') {
        var rsp = response.data.info.result;
        this.totalrows = response.totalRegistros;
        this.fromSearchButtom = true;
      }
    }, (err) => {
      this.loadingTotalRows = false;
      if (err.error.message == null) {
        this.alerta.AlertaCatch(err);
      } else {
        this.alerta.AlertaError(err.error.message);
      }
    });
  }

  buscarPersona() {
    this.fromSearchButtom = false;
    // this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
    // this.personaResultados = [];
    this.total = 0;
    this.totalRegistros = 0;

    this.persona.PersonalidadFiscalId = +this.persona.PersonalidadFiscalId;
    this.persona.EstatusId = +this.persona.EstatusId;
    this.persona.AreaId = +this.persona.AreaId;
    this.persona.SucursalId = +this.persona.SucursalId;
    this.persona.NoCuenta = this.persona.NoCuenta;
    this.personaResultados = [];
    this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
    if (this.persona.TipoPersona == 2) {
      if (!this.persona.CURP || this.persona.CURP.trim() === '') {
        this.persona.CURP = "";
      }
      if (!this.persona.FechaInicialRegistro) {
        this.persona.FechaInicialRegistro = "";
      }
      if (!this.persona.FechaFinalRegistro) {
        this.persona.FechaFinalRegistro = "";
      }
      this.persona.RiesgoId = this.persona.RiesgoId;
    }
    if (this.persona.TipoPersona == 1) {
      this.persona.FechaInicialRegistro = "";
      this.persona.FechaFinalRegistro = "";
      this.persona.CURP = "";
      this.persona.RiesgoId = -1;
    }
    this.personaService.buscar(this.persona).subscribe(response => {
      this.main.loading = false;
      if (response == null) {
        this.alerta.AlertaError(
          'Existe un error, si persiste contacte al administrador del Sitio.'
        );
      } else if (response.isCorrect === 'false') {
        this.persona.Pagina > 1 ? this.persona.Pagina-- : this.persona.Pagina = 1;
        this.alerta.AlertaError(response.message);
      } else if (response.totalRegistros == 0) {
        this.persona.Pagina > 1 ? this.persona.Pagina-- : this.persona.Pagina = 1;
        this.personaResultados = [];
        this.data = [];
        this.columns = [];
        this.total = 0;
        this.totalRegistros = 0;
        this.alerta.AlertaSinResultados(response.message);
      } else {
        this.data = response.data.info.result.data;
        this.columns = response.data.info.result.columns;
      }
    }, (err) => {
      this.main.loading = false;
      this.total = 0;
      this.alerta.AlertaCatch(err);
    });
  }

  cambiarTipoPersona(tipoPersona) {
    this.resultadoPaginadoTotal = [];
    this.total = 0;
    this.totalRegistros = 0;
    if (this.persona.TipoPersona == 2 || this.persona.TipoPersona == 3) {
      this.persona.TipoPersona = +tipoPersona;
      this.tipoPersona = tipoPersona;
    }
  }

  generarReporteGeneral() {
    this.alerta.AlertaSuccessTimer("El Reporte se descargará en breve.")
    this.main.loading = true;
    this.generarReporteAsync().then(response => {
      this.alerta.AlertaSuccessTimer('El Reporte General se ha generado con éxito.');
      this.main.loading = false;
    }).catch(error => this.alerta.AlertaError(error));
    this.main.loading = false;
  }

  nameReport() {
    let nameReporteExcel: string;

    if (this.persona.TipoPersona == 1) {
      nameReporteExcel = "Empleados";
    }
    else if (this.tipoPersonaCombo == 2) {
      nameReporteExcel = "Clientes";
      this.persona.TipoPersona = 2;
    }
    else if (this.tipoPersonaCombo == 3) {
      nameReporteExcel = "PersonasRelacionadas";
      this.persona.TipoPersona = 3;
    }
    return nameReporteExcel;
  }

  paginador(value) {
    this.main.loading = true;
    if (value) {
      this.persona.Pagina++;
      this.contador++;
      this.buscarPersona();
    }
    if (!value) {
      this.persona.Pagina--;
      this.contador--;
      this.buscarPersona();
    }
  }

  detallePersona(personaId: number) {
    this.main.loading = true;
    this.comunicacion.limpiarStorage(false);
    this.comunicacion.setPersona(personaId);
    if (this.persona.TipoPersona == 1) {
      this.comunicacion.setPersonaTipo(this.persona.TipoPersona);
    } else {
      this.comunicacion.setPersonaTipo(this.tipoPersonaCombo);
    }
    setTimeout(() => {
      this.router.navigate(['/v2/detallepersona']);
    }, 2000);
  }

  onItemChange(value, persona) {
    this.alertaService.buscando = false;
    this.alertaService.persona = persona;
  }

  isValidNumberInput(): boolean {
    return /^\d*$/.test(this.persona.ClaveCia);
  }

  async validateStreamDownload() {
    if (this.totalrows == 0) {
      this.alerta.AlertaSinResultados(`No se encontraron resultados.`);
    } else if (this.totalrows > AppConstants.MAX_ROWS_PER_REPORT_VALIDATE) {
      Swal.fire({
        title: "Consulta demasiado grande",
        html: `El límite máximo de la consulta es ${AppConstants.MAX_ROWS_PER_REPORT_VALIDATE / 1000000}
        millones de filas.`,
        reverseButtons: true
      }).then((rsp) => {
        if (rsp.value) {
          console.log("El usuario aceptó");
        }
      });
    } else {
      this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataReport;
      await this.streamDownload();
    }
  }

  async streamDownload() {
    this.abortCtrl = new AbortController();
    this.main.loading = true;
    try {
      var fileName = this.persona.TipoPersona == 1 ? "Empleados" : "Clientes";
      var numExcel = Math.ceil(this.totalrows / AppConstants.MAX_ROWS_PER_EXCEL);
      this.alerta.AlertaSuccessTimer(`Se descargarán ${numExcel} archivos.`);
      const rsp = await this.sHelper.Personas(this.persona, this.abortCtrl.signal);
      if (!rsp.ok) throw new Error("Error en servidor");
      const fileStream = createWriteStream(`${fileName}_${Date.now()}.zip`);
      await rsp.body!.pipeTo(fileStream);
      this.alerta.alertaInfo('Descarga completada');
    } catch (err) {
      this.alerta.AlertaError("Descarga fallida. El navegador limpiará el temporal.");
    } finally {
      this.main.loading = false;
    }
  }

  // funciones de tabla dinamica
  onTableAction(e: { action: string; row: any }) {
    if (e.action === 'detail') {
      this.detallePersona(e.row.personaId)
    }
  }

  onNewBatch(event: { batchNumber: number, page: number }) {
    this.fromSearchButtom = true;
    this.buscarPersona();
  }

  onPrintReport() {
    this.validateStreamDownload();
  }

  seleccionarNivelRiesgo(riesgoId: number) {
    if (riesgoId == -1) {
      this.isNivelRiesgo = true;
    } else {
      this.isNivelRiesgo = false;
    }
  }

  validarSoloTexto(event: KeyboardEvent, text: string, numCaharacter: number) {
    return this.Helpers.validarTexto(event, text, numCaharacter)
  }

  onChangePersonalidadFiscal() {
    if (this.persona.PersonalidadFiscalId == 2) {
      this.persona.CURP = "";
      this.persona.RiesgoId = -1;
      this.persona.FechaInicialRegistro = "";
      this.persona.FechaFinalRegistro = "";
    } else {
      const FORMATO_SALIDA = 'YYYY-MM-DD';
      const FORMATO_ENTRADA = 'YYYY-MM-DDTHH:mm:ss Z';
      const fechainicial = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1), FORMATO_ENTRADA);
      const fechafinal = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), FORMATO_ENTRADA);
      this.persona.FechaInicialRegistro = fechainicial.format(FORMATO_SALIDA);
      this.persona.FechaFinalRegistro = fechafinal.format(FORMATO_SALIDA);
    }
  }
}
